import { BASE_URL } from './../../Api/ApiUrls';

/**
 * Get upload availability per posted_by
 */
export const checkPropertyUploadPermission = async (userId) => {
  try {
    /* -------------------------------
       1. FETCH SUBSCRIPTIONS
    -------------------------------- */
    const subRes = await fetch(`${BASE_URL}/Get-user-plan/${userId}/`);
    if (!subRes.ok) {
      return { allowed: false, message: "Please take a subscription" };
    }

    const subscriptions = await subRes.json();
    if (!Array.isArray(subscriptions) || subscriptions.length === 0) {
      return { allowed: false, message: "Please take a subscription" };
    }

    const allowedUserTypes = ["Agent", "Individual Owner/Builder"];

    const validPlans = subscriptions.filter(sub =>
      allowedUserTypes.includes(sub.user_type)
    );

    if (validPlans.length === 0) {
      return {
        allowed: false,
        message: "Your subscription does not allow property uploads",
      };
    }

    /* -------------------------------
       2. FETCH USER PROPERTIES
    -------------------------------- */
    const propRes = await fetch(`${BASE_URL}/get-property/${userId}/`);
    if (!propRes.ok) {
      return { allowed: false, message: "Unable to verify properties" };
    }

    const properties = await propRes.json();

    /* -------------------------------
       3. COUNT PER POSTED_BY
    -------------------------------- */
    const counts = {
      Agent: 0,
      Owner: 0,
      Builder: 0,
    };

    properties.forEach((p) => {
      if (p.posted_by && counts[p.posted_by] !== undefined) {
        counts[p.posted_by]++;
      }
    });

    /* -------------------------------
       4. BUILD AVAILABILITY MAP
    -------------------------------- */
    const availability = {};

    validPlans.forEach((plan) => {
      const role =
        plan.user_type === "Agent"
          ? "Agent"
          : "Individual Owner/Builder";

      if (plan.no_of_properties_unlimited) {
        availability[role] = {
          allowed: true,
          remaining: "Unlimited",
        };
      } else {
        const used = counts[role === "Agent" ? "Agent" : "Owner"] || 0;
        availability[role] = {
          allowed: used < plan.no_of_properties,
          remaining: Math.max(plan.no_of_properties - used, 0),
        };
      }
    });

    return {
      allowed: Object.values(availability).some(v => v.allowed),
      availability,
    };

  } catch (error) {
    console.error(error);
    return {
      allowed: false,
      message: "Something went wrong while checking subscription",
    };
  }
};
